// @flow
import PropTypes from "prop-types";

const SampleLegend = ({useFill}) => {
    
    const fillClass = useFill ? "filled" : "";
    
    return(<div className="li-bg-blue-card p-1 text-center ">
            <div className="row justify-content-around">
                <div>Sample Legend</div>
                <div>
            <div className="li-sample-legend-chunk left">
                <div className={"badge li-bg-blue li-fg-white " + fillClass}>
                    <i className="fa fa-check-circle"/> ok
                </div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-duplicate " + fillClass}>Duplicate</div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-missing-barcode li-fg-black " + fillClass}>Missing Barcode</div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-missing-profile li-fg-white " + fillClass}>Missing Profile</div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-danger li-fg-white " + fillClass}>Missing Case or Sample</div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-dark li-fg-white " + fillClass}>Details Mapped Later</div>
            </div>
            <div className="li-sample-legend-chunk">
                <div className={"badge li-bg-concern-color " + fillClass}>In Wrong Mag/Rack</div>
            </div>
                </div>
            </div>
        </div>);
}

SampleLegend.propTypes = {
    useFill: PropTypes.bool
};

export default SampleLegend;